import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../features/Navbar'
import church from '../assets/church.jpg'
import Card from '../components/Card';
import map from '../assets/map.jpg';
import locate from '../assets/locate.svg'



const Location = () => {
  return (
    <div>
      <div className='sticky top-0 z-50'>
        <Navbar />
      </div>

      <div className="w-screen relative flex items-center justify-center">
      <img className="object-cover w-screen h-[30em]" src={church} alt="Hero" />
      <h2 className='absolute text-center text-white text-2xl md:text-4xl font-bold top-[30%] mx-4'>Check out the Location of our Headquaters at Idimu and other branches closer to you.</h2>
     <span className='absolute top-[55%] md:top-[60%] lg:top-[55%]'>
     <a target='blank' href='https://maps.app.goo.gl/eLK45X8NxAzxozZw6'> 
     <button className="flex justify-center items-center rounded-lg transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300 h-[50px] w-[180px]">
    <span> <img className="h-12 w-12" src={locate} alt="locate" /></span>
              </button></a>
              </span>
</div>
      
      <div className='flex justify-center gap-5 flex-wrap mt-[50px]'>
      <Card
            header='Diamond Branch'
            description='Check out the location of our Diamond Branch at Diamond Estate,Lagos.'
            image={map}
            href='/locate'
            btnText='Locate'
          />
          <Card
            header='Ijoko Branch'
            description='Check out our branch in Ijoko,Ogun state'
            image={map}
            href='/locate'
            btnText='Locate'
          />
          <Card
            header='Ilogbo Branch'
            description='Check out the location of our branch in Ilogbo,Ondo state'
            image={map}
            href='/locate'
            btnText='Locate'
          />
          <Card
            header='Badagry Branch'
            description='Check out the location of our branch in Badagry, Lagos state'
            image={map}
            href='/locate'
            btnText='Locate'
          />
      </div>
<section className='mt-[50px]'>
      <Footer/>
      </section>
    </div>
  )
}

export default Location